import { generateDarkModePalette } from '@thoughtspot/radiant-react/widgets/color';
export function adaptChartPalettesForDarkMode(palettes, isDarkMode) {
    if (!isDarkMode || !Array.isArray(palettes))
        return palettes;
    return palettes.map(palette => ({
        ...palette,
        colors: generateDarkModePalette(palette.colors),
    }));
}
//# sourceMappingURL=dark-mode-palette.util.js.map